import React from 'react';
import { connect } from 'react-redux';
// import { Link } from 'react-router-dom';
import { getParameterByName } from '../../../../helpers/location';
import FlopWidget from '../Widgets/FlopWidget'

const FlopDashboard = props => (
    <div id="players-dashboard">
        <header className="content-header">
            <h1>
                Top Flop
                <small>dashboard</small>
            </h1>
            <ol className="breadcrumb">
                <li><i className="fa fa-wrench"/> Tools</li>
                <li className="text-bold">Flop</li>
            </ol>
        </header>
        <section className="content">
            <FlopWidget championship={parseInt(getParameterByName('championship', props.location.search), 10)}/>
        </section>
    </div>
);

export default connect(
    () => ({}),
    dispatch => ({ dispatch }),
)(FlopDashboard);



// WEBPACK FOOTER //
// ./src/pages/Tools/Topflop/Dashboard/FlopDashboard.js